module.exports = __webpack_public_path__ + "static/img/H9_2.1747948.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/q_and_a/H9_2.png
// module id = i4Wv
// module chunks = 0